import {
    instance as axios,
    setJwtToken,
    setMultiPartHeader,
} from "../../config/axiosInstance";
// ------------------------user Detail---------------------

export const profileDetailApi = async (data) => {
  const endPoint =
      `profile` +
      "?" +
      new URLSearchParams({ ...data }).toString();

  return await axios.get(endPoint, setJwtToken());
};
  // ------------------------Edit SubAdmin------------------
  export const editProfileApi = async (data) => {
    const endPoint = `profile`;
    return await axios.put(endPoint, data, setMultiPartHeader());
  };
  